import { buildPublicLoginHref } from './publicPortalLinks';
import { AUTH_LOGIN_TARGETS, authLoginTargetFromLocation, normalizeAuthLoginTarget } from '../../shared/authLoginTargets';

export const PUBLIC_PORTAL_LOGIN_INTENT_KEY = 'math-platform-public-login-intent';
export const PUBLIC_PORTAL_LOGIN_HASH = AUTH_LOGIN_TARGETS.student;

const WINDOW_NAME_TOKEN = 'math-platform:public-login-intent';

export function requestPublicPortalLoginIntent() {
  writeSessionIntent();
  writeWindowNameIntent();
}

export function hasPublicPortalLoginIntent(search = '', hash = currentHash(), pathname = currentPathname()) {
  return Boolean(publicPortalLoginTargetFromLocation(pathname, hash)) || legacyLoginQueryRequested(search) || readSessionIntent() || readWindowNameIntent();
}

export function consumePublicPortalLoginIntent(search = '', hash = currentHash(), pathname = currentPathname()) {
  const requested = hasPublicPortalLoginIntent(search, hash, pathname);
  clearSessionIntent();
  clearWindowNameIntent();
  return requested;
}

export function publicPortalLoginHashRequested(hash = currentHash()) {
  return Boolean(publicPortalLoginTargetFromLocation(currentPathname(), hash));
}

export function ensurePublicPortalLoginUrl(replace = false, homeHref = '/', target = AUTH_LOGIN_TARGETS.student) {
  const nextUrl = buildPublicLoginHref(homeHref, normalizeAuthLoginTarget(target) || AUTH_LOGIN_TARGETS.student);
  if (replace) {
    window.history.replaceState(window.history.state || {}, '', nextUrl);
    return;
  }
  window.history.pushState({}, '', nextUrl);
}

export function legacyLoginQueryRequested(search = '') {
  return new URLSearchParams(search).get('login') === '1';
}

function currentHash() {
  return typeof window === 'undefined' ? '' : window.location.hash;
}

function currentPathname() {
  return typeof window === 'undefined' ? '' : window.location.pathname;
}

export function publicPortalLoginTargetFromLocation(pathname = currentPathname(), hash = currentHash()) {
  return authLoginTargetFromLocation(pathname, hash);
}

function readSessionIntent() {
  try {
    return window.sessionStorage.getItem(PUBLIC_PORTAL_LOGIN_INTENT_KEY) === '1';
  } catch (error) {
    return false;
  }
}

function writeSessionIntent() {
  try {
    window.sessionStorage.setItem(PUBLIC_PORTAL_LOGIN_INTENT_KEY, '1');
  } catch (error) {
    // Best-effort only; window.name covers local multi-port handoff.
  }
}

function clearSessionIntent() {
  try {
    window.sessionStorage.removeItem(PUBLIC_PORTAL_LOGIN_INTENT_KEY);
  } catch (error) {
    // Nothing to clear when tab storage is unavailable.
  }
}

function readWindowNameIntent() {
  return windowNameParts().includes(WINDOW_NAME_TOKEN);
}

function writeWindowNameIntent() {
  const parts = windowNameParts();
  if (!parts.includes(WINDOW_NAME_TOKEN)) {
    parts.push(WINDOW_NAME_TOKEN);
  }
  window.name = parts.join('\n');
}

function clearWindowNameIntent() {
  const parts = windowNameParts().filter(part => part !== WINDOW_NAME_TOKEN);
  window.name = parts.join('\n');
}

function windowNameParts() {
  return String(window.name || '').split('\n').filter(Boolean);
}
